<div class="container">
  <app-back-arrow-button [label]="'TGA.Notifications.History.BackToTGA' | translate" [action]="navigateToTGAInsights" />

  <div class="page-header">
    <h1>{{ 'TGA.Notifications.History.Title' | translate }}</h1>
    <app-crop-year-selector [readOnly]="true" />
  </div>

  <div class="tab-container" role="tablist" aria-label="Notification categories">
    @for (tab of tabs; track tab.index) {
      <button
        class="tab-button"
        mat-button
        role="tab"
        [attr.aria-label]="'TGA.Notifications.History.' + tab.key | translate"
        [attr.aria-selected]="isTabActive(tab.index)"
        [class.active]="isTabActive(tab.index)"
        (click)="selectTab(tab.index)"
      >
        {{ 'TGA.Notifications.History.' + tab.key | translate }}
      </button>
    }
  </div>

  <div class="content-wrapper" role="tabpanel">
    @if ((totalLength$ | async) === 0) {
      <agr-notification-empty
        [isEmpty]="true"
        [emptyDescription]="getEmptyStateKey() | translate"
        [showEmptyAction]="false"
        [attr.aria-live]="'polite'"
      />
    } @else {
      <mat-table
        [dataSource]="paginatedData$"
        class="notification-table"
        matSort
        (matSortChange)="sortData($event)"
        aria-label="Notification history table"
      >
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'TGA.Notifications.History.DateColumn' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.date | date: 'dd-MM-yyyy' : '' : localeString }}
          </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'TGA.Notifications.History.TypeColumn' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ getNotificationTypeLabel(item.type) }}
          </mat-cell>
        </ng-container>

        <!-- Crop Field Column -->
        <ng-container matColumnDef="cropField">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'TGA.Notifications.History.CropFieldColumn' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.cropFieldName || '-' }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50]"
        [length]="totalLength$ | async"
        (page)="page($event)"
      ></mat-paginator>
    }
  </div>
</div>
